
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/best-getchat-alternative",
      function () {
        return require("private-next-pages/best-getchat-alternative.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/best-getchat-alternative"])
      });
    }
  